import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WifidetailsComponent } from './wifidetails.component';

const routes: Routes = [
    {
        path: '',
        component: WifidetailsComponent,
        data: {
            title: 'Wifi Details'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WifidetailsRoutingModule { }
